import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import { ApolloProvider } from '@apollo/client';
import AmplifyInit from 'aws/aws-api';
import client from 'apollo/client';
import * as Sentry from "@sentry/react";

AmplifyInit();

if (import.meta.env.PROD) {
  const ahrefs = document.createElement("script");
  ahrefs.src = "https://analytics.ahrefs.com/analytics.js";
  ahrefs.async = true;
  ahrefs.setAttribute("data-key", "SA+p3WbOdL9MMDf4Equ4qQ");
  document.head.appendChild(ahrefs);

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-W4375XSZ");

  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = "https://www.googletagmanager.com/gtag/js?id=G-PMH9XQHFPY";
  document.head.appendChild(gtagScript);

  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", "G-PMH9XQHFPY");

  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://static.klaviyo.com/onsite/js/VM5isW/klaviyo.js';
  document.body.appendChild(s);
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/develop\.saddlefit\.io\//,
    /^https:\/\/staging\.saddlefit\.io\//,
    /^https:\/\/saddlefit\.io\//
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();